function update_url(resp) {
    if (window.history && "pushState" in window.history) {
        const url = resp.data.data.url;
        window.history.pushState(null, "", url);
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = url;
        }
    }
}

function groupBy(objectArray, property, value) {
    return objectArray.reduce(function (acc, obj) {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj[value]);
        return acc;
    }, {});
}

function getFormData(filter_form) {
    let formData = new FormData(filter_form);
    let object = [];
    formData.forEach(function (value, key) {
        const o = {
            name: key,
            value: value,
        };
        object.push(o);
    });
    const pieces = groupBy(object, "name", "value");
    formData = new FormData();
    for (const piece in pieces) {
        if (pieces.hasOwnProperty(piece)) {
            formData.append(piece, pieces[piece].join("|"));
        }
    }
    return formData;
}

function oiFilterDisableForm(oi_filter_form) {
    if (oi_filter_form) {
        const focused = document.activeElement;
        for (let i = 0; i < oi_filter_form.elements.length; i++) {
            if (oi_filter_form.elements[i] === focused) {
                continue;
            }
            oi_filter_form.elements[i].setAttribute("disabled", "disabled");
        }
        const to_disable = oi_filter_form.querySelectorAll(".oi-disable-while-pending");
        to_disable.forEach(el => {
            if (el !== focused) {
                el.setAttribute("disabled", "disabled");
            }
        });

        const model_filters = oi_filter_form.querySelectorAll(".model-filters");
        model_filters.forEach(el => el.style.opacity = "0.6");
    }
}

function oiFilterEnableForm(oi_filter_form) {
    if (oi_filter_form) {
        setTimeout(() => {
            for (let i = 0; i < oi_filter_form.elements.length; i++) {
                oi_filter_form.elements[i].disabled = false;
                oi_filter_form.elements[i].removeAttribute("disabled");
            }
            const to_disable = oi_filter_form.querySelectorAll(".oi-disable-while-pending");
            to_disable.forEach(el => {
                el.disabled = false;
                el.removeAttribute("disabled");
            });
            const model_filters = oi_filter_form.querySelectorAll(".model-filters");
            model_filters.forEach(el => el.style.opacity = "1");
        }, 500);
    }
}

function oiFilterAjaxBeforesend(oi_filter_form, from_infinite) {
    if (!from_infinite) {
        oiFilterDisableForm(oi_filter_form);
    }
}

function oiFilterGetResults(oi_filter_form, results) {
    let ftype = oi_filter_form.dataset.filterType;
    const url = `/xhr/filter/${ftype}/`;
    const formData = getFormData(oi_filter_form);
    const detailPage = oi_filter_form.dataset.detailPage || false;

    if (results) {
        results.setAttribute("aria-busy", "true");
    }

    oi.axios({
        method: "post",
        url: url,
        data: formData,
        headers: { "Content-Type": "application/json" },
        transformRequest: [function (data, headers) {
            oiFilterAjaxBeforesend(oi_filter_form, false);
            return data;
        }],
    })
    .then(function (resp) {
        if (resp.data.data.result_list) {
            if (resp.data.options) {
                const options = resp.data.options;
                for (const id in options) {
                    if (options.hasOwnProperty(id)) {
                        let el = document.getElementById(id);
                        if (el) {
                            el.innerHTML = options[id];
                        } else {
                            console.warn(`Element with ID "${id}" not found.`);
                        }
                    }
                }
            }

            if (resp.data.paginator && resp.data.paginator !== "") {
                const pageinput = oi_filter_form.querySelector('input[name="page"]');
                if (pageinput) {
                    pageinput.value = resp.data.paginator.next;
                }
            }

            if (results) {
                results.innerHTML = resp.data.data.result_list;
            }

            const oi_filter_amount = document.getElementById("oi-filter-amount");
            if (oi_filter_amount && resp.data.data.amount !== undefined) {
                const amount = resp.data.data.amount;
                oi_filter_amount.textContent = `${amount} result${amount === 1 ? "" : "s"}`;
            }

            update_url(resp);

            if (window.afterResultsSuccess !== undefined) {
                window.afterResultsSuccess();
            }

            if (oi.loaded.map['oi-map'] && !detailPage) {
                if (ftype === 'lot' || ftype === 'mlslisting') {
                    ftype = 'location';
                }
                oi.loaded.map['oi-map'].set_markers(ftype);
                oi.loaded.map['oi-map'].fit();
                if (typeof window.oiNameMapMarkers === "function") {
                    window.oiNameMapMarkers("oi-map");
                }
            }
        }
    })
    .catch(function (error) {
        if (error.response) {
            if (error.response.status == 400) {
                let msg = "";
                const errors = error.response.data.errors;
                for (let err in errors) {
                    let x = errors[err];
                    msg = `${x.code} - ${x.description}\n`;
                }
                oiFilterEnableForm(oi_filter_form);
            } else if (error.response.status == 302) {
                window.location.href = error.response.data.data.redirect;
            }
        } else {
            console.error(error.message);
        }
    })
    .then(function () {
        if (results) {
            results.setAttribute("aria-busy", "false");
        }
        const name_input = oi_filter_form.querySelector('input[name="m"]');
        if (name_input !== null) {
            name_input.value = "0";
        }
        oiFilterEnableForm(oi_filter_form);
    });
}

window.addEventListener("load", () => {
    const all_oi_filter_forms = document.querySelectorAll(".oi-filter-form");

    all_oi_filter_forms.forEach((oi_filter_form) => {
        const oi_filter_clickables = oi_filter_form.querySelectorAll(".oi-filter-click");
        const oi_filter_changables = oi_filter_form.querySelectorAll(".oi-filter-change");
        const oi_filter_reset = oi_filter_form.querySelectorAll(".oi-filter-reset");
        const oi_filter_results = document.getElementById("oi-filter-results"); // Only one shared on listings page

        oi_filter_clickables.forEach((elem) => {
            elem.addEventListener("click", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });

        oi_filter_form.addEventListener("submit", (e) => {
            e.preventDefault();
            oiFilterGetResults(oi_filter_form, oi_filter_results);
        });

        oi_filter_changables.forEach((elem) => {
            elem.addEventListener("change", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });

        if (oi_filter_reset.length && oi_filter_results) {
            oi_filter_reset.forEach((btn) => {
                btn.addEventListener("click", (e) => {
                    e.preventDefault();
                    const to_clear = oi_filter_form.querySelectorAll(".oi-clear-on-reset");
                    to_clear.forEach((input) => {
                        if (input.type === "select-one") {
                            input.selectedIndex = 0;
                        } else if (input.id === "boyl-input") {
                            input.value = false;
                        } else if (input.type === "checkbox") {
                            input.checked = false;
                        }
                    });

                    const buttons_to_reset = oi_filter_form.querySelectorAll(".filter-button-on");
                    buttons_to_reset.forEach((btn) => {
                        btn.classList.remove("filter-button-on");
                    });

                    oiFilterGetResults(oi_filter_form, oi_filter_results);
                });
            });
        }
    });

    window.addEventListener("popstate", () => {
        location.reload();
    });
});